export default "__VITE_ASSET__C8ICYd2g__"